function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, visible) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'mp-message-banner-visible': visible,
        }, {
          'mp-message-banner-container': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((visible) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-banner", {
            "attrs": __vjadeStringifyAttrsIfObj({
              theme: $attr(`type`),
              'header-text': $attr(`title`),
              'body-text': $attr(`message`),
              'size': $attr(`size`),
              'ctas': JSON.stringify($attr(`closeable`) ? [{
                text: `Dismiss`,
                actionName: `dismiss`,
              }] : [])
            }),
            "on": {
              action: $helpers.hideBanner
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "visible" in locals ? locals.visible : typeof visible !== "undefined" ? visible : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;